"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useContext } from "react";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { Tooltip } from "react-tooltip";
import { AuthContext } from "@/components/auth/Auth";
import { useWaveEligibility } from "@/contexts/wave/WaveEligibilityContext";
interface WaveDropActionsReplyProps {
  readonly drop: ApiDrop;
  readonly activePartIndex: number;
  readonly onReply: () => void;
}
const WaveDropActionsReply: React.FC<WaveDropActionsReplyProps> = t0 => {
  const $ = _c(24);
  const {
    onReply,
    drop
  } = t0;
  const {
    setToast
  } = useContext(AuthContext);
  const {
    getEligibility
  } = useWaveEligibility();
  let t1;
  if ($[0] !== drop.id) {
    t1 = drop.id.startsWith("temp-");
    $[0] = drop.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isTemporaryDrop = t1;
  let t2;
  if ($[2] !== drop.wave.id || $[3] !== getEligibility) {
    t2 = getEligibility(drop.wave.id);
    $[2] = drop.wave.id;
    $[3] = getEligibility;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const waveEligibility = t2;
  const isEligibleToChat = waveEligibility?.authenticated_user_eligible_to_chat ?? drop.wave.authenticated_user_eligible_to_chat;
  const canReply = !isTemporaryDrop;
  let t3;
  if ($[5] !== isEligibleToChat || $[6] !== onReply || $[7] !== setToast) {
    t3 = () => {
      if (isEligibleToChat === false) {
        setToast({
          message: "You are not eligible to chat in this wave",
          type: "error"
        });
        return;
      }
      onReply();
    };
    $[5] = isEligibleToChat;
    $[6] = onReply;
    $[7] = setToast;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleReplyClick = t3;
  const t4 = `tw-text-iron-500 icon tw-px-2 tw-h-full tw-group tw-bg-transparent tw-rounded-full tw-border-0 tw-flex tw-items-center tw-gap-x-1.5 tw-text-xs tw-leading-5 tw-font-medium tw-transition tw-ease-out tw-duration-300 ${!canReply ? "tw-opacity-50 tw-cursor-default" : "tw-cursor-pointer"}`;
  const t5 = canReply ? handleReplyClick : undefined;
  const t6 = !canReply;
  const t7 = !isTemporaryDrop ? `reply-${drop.id}` : undefined;
  const t8 = `tw-flex-shrink-0 tw-w-5 tw-h-5 tw-transition tw-ease-out tw-duration-300 ${!canReply ? "tw-opacity-50" : ""}`;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <path strokeLinecap="round" strokeLinejoin="round" d="M7.49 12 3.74 8.248m0 0 3.75-3.75m-3.75 3.75h16.5V19.5" />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t8) {
    t10 = <svg className={t8} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">{t9}</svg>;
    $[10] = t8;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t4 || $[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t11 = <button className={t4} onClick={t5} disabled={t6} aria-label="Reply to drop" data-tooltip-id={t7}>{t10}</button>;
    $[12] = t10;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== drop.id || $[19] !== isTemporaryDrop) {
    t12 = !isTemporaryDrop && <Tooltip id={`reply-${drop.id}`} place="top" style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }}><span className="tw-text-xs">Reply</span></Tooltip>;
    $[18] = drop.id;
    $[19] = isTemporaryDrop;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t11 || $[22] !== t12) {
    t13 = <>{t11}{t12}</>;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  return t13;
};
export default WaveDropActionsReply;